import { createGlobalStyle } from 'styled-components/macro'

export const GlobalStyle = createGlobalStyle`
  body, #root {
    min-height: 100%;
    overflow-x: hidden;
  }
  #root {
    display: flex;
    flex-direction: column;
  }
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    font-family: 'Lato', sans-serif !important;
    font-size: ${({ theme }) => theme.fontSizes.small};
 }
 .error-input {
  font-size: 11px;
  color: red;
  margin-left: 4px;
 }

 ul.ant-menu-root {
  position: fixed;
  width: 100%;
  z-index: 999;
 }
`
